import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import DialogModal from "../../common/DialogModal";
import Button from "../../Parts/Button";

const styles = () => ({
  paper: {
    maxHeight: "unset",
    background: "#F4F6F9",
    width: "600px",
  },

  contentContainer: {
    padding: 25,
    margin: 0,
    textAlign: "left",
  },

  buttonContainer: {
    display: "inline-flex",
    width: "100%",
    justifyContent: "space-between",
    marginTop: 40,
  },
});

class ConfirmFollowCallDialog extends React.Component {
  handleClick = (flag) => {
    this.props.handleClickFollowCall(flag);
    this.props.toggleDialog();
    this.props.order();
  }

  render() {
    const { classes, toggleDialog } = this.props;

    return (
      <DialogModal
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer,
        }}
        open={this.props.isOpen}
        maxWidth={false}
        onClose={toggleDialog}
        title={'フォローコール'}
      >
        <Typography variant="subheading">
          フォローコールを依頼して注文すると、電話をした際に得たリード情報や、録音した音声を確認することができます。<br />
          また、リード情報の獲得や商談の獲得はレターダッシュボードから随時確認いただけます。
        </Typography>
        <div className={classes.buttonContainer}>
          <Button
            handleClickButton={() => this.handleClick(false)}
            size="large"
            text="フォローコールを依頼せずに注文"
            style={{ background: '#A2A2A2', width: 264, padding: '0 20px' }}
          ></Button>
          <Button
            handleClickButton={() => this.handleClick(true)}
            size="large"
            text="フォローコールを依頼して注文"
            style={{ width: 264, padding: '0 20px' }}
          ></Button>
        </div>
      </DialogModal>
    );
  }
}

ConfirmFollowCallDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  handleClickFollowCall: PropTypes.func.isRequired,
  order: PropTypes.func.isRequired,
};

export default withStyles(styles)(ConfirmFollowCallDialog);



// WEBPACK FOOTER //
// ./src/components/SendLetter/dialogs/ConfirmFollowCallDialog.jsx